export const TENANT_CODES = ['500021', '5000228', '50105', '7000112', '700016', '530003', '530021'];
